import * as React from 'react';
import { Tab } from '../../internal/Tab/Tab';
import { ScrollTrack } from '../../internal/ScrollTrack/ScrollTrack';
import { TTabsTheme } from '../../types';

export interface ITabsProps {
  /**
   * value активного таба
   */
  activeTab: string;
  /**
   * Массив табов
   */
  tabs: ITabProps[];
  /**
   * Компонент не хранит активное состояние, для установке нового активного состояния используется onChange,
   * передает в качестве аргумента значение по которому был сделан клик/тап
   */
  onChange(value: string): void;
  /**
   * Цветовая тема для панели табов
   */
  theme?: TTabsTheme;
}

export interface ITabProps {
  /**
   * Идентификатор таба, используется для определения активного таба, передается в onChange при изменении
   */
  value: string;
  /**
   * Отображается в интерфейсе
   */
  title: number | string;
  /**
   * Задисейбленый таб невозможно выбрать, для него не вызваются обработчики
   */
  disabled?: boolean;
}

const TabsComponent: React.FC<ITabsProps> = ({ activeTab, tabs, onChange, theme }) => {
  const [focusVisible, setFocusVisible] = React.useState(false);
  const currentTheme: TTabsTheme = theme || 'light';

  const onClick = ({ value }: { e: React.MouseEvent; value: string }) => {
    setFocusVisible(false);
    onChange(value);
  };

  return (
    <ScrollTrack setFocusVisible={setFocusVisible} activeTab={activeTab} theme={currentTheme}>
      <>
        {tabs.map(({ value, title, disabled }) => (
          <Tab
            key={value}
            title={title}
            disabled={disabled}
            active={value === activeTab}
            focusVisible={focusVisible}
            onClick={e => onClick({ e, value })}
            theme={currentTheme}
          />
        ))}
      </>
    </ScrollTrack>
  );
};

/**
 * Компонент для рендера табов со стрелками прокрутки
 */
export const Tabs = React.memo(TabsComponent);
